export default {
  name: "UK",
  NorthBound: 60.9,
  EastBound: 2.021484375,
  SouthBound: 49.82380908513249,
  WestBound: -10.854492187,
};
